import React, { Component } from 'react'

import './style.css'

class Footer extends Component {
  componentWillMount () {
    // console.log()
  }
  render () {
    return <div />
    // <div className="footer">
    //   Footer
    // </div>
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/common/Footer/Footer.js